import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const exchange = async () => {
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user: data.user } });
      } catch {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true });
      }
    };
    if (sessionId) exchange();
    else navigate("/admin", { replace: true });
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-navy-950 flex items-center justify-center" data-testid="auth-callback-screen">
      <div className="flex items-center gap-3 text-ink-dim">
        <Loader2 className="animate-spin text-gold" size={20} />
        <span className="font-mono text-xs uppercase tracking-[0.25em]">Signing you in…</span>
      </div>
    </div>
  );
}
